module.exports = __webpack_public_path__ + "img/closed-upArrow.eedc597f.svg";